import React from "react";
import { GenericCrud, useFetch } from "@/components/common";

const CATS = ["U8", "U9", "U10", "U11", "U12", "U13", "U14", "U15"];

export default function Matches() {
  const { data: teams } = useFetch("/teams", []);
  const teamOpts = (teams || []).map((t) => ({ value: t.id, label: t.name }));
  const teamName = (id) => (teams || []).find((t) => t.id === id)?.name || "—";

  return (
    <GenericCrud
      title="Matches" subtitle="Match schedule, scores and statistics" endpoint="/matches" testid="matches"
      columns={[
        { key: "date", label: "Date" },
        { key: "opponent", label: "Opponent", render: (r) => <span className="font-semibold">{r.opponent}</span> },
        { key: "team", label: "Team", render: (r) => teamName(r.team_id) },
        { key: "score", label: "Score", render: (r) => (r.score_home != null && r.score_away != null) ? `${r.score_home} - ${r.score_away}` : "—" },
        { key: "competition", label: "Competition" },
        { key: "stadium", label: "Stadium" },
      ]}
      fields={[
        { key: "opponent", label: "Opponent" },
        { key: "team_id", label: "Team", type: "select", options: teamOpts },
        { key: "date", label: "Date", type: "date" },
        { key: "time", label: "Time", type: "time" },
        { key: "stadium", label: "Stadium" },
        { key: "competition", label: "Competition" },
        { key: "category", label: "Category", type: "select", options: CATS.map((c) => ({ value: c, label: c })) },
        { key: "result", label: "Result", type: "select", options: [{ value: "win", label: "Win" }, { value: "draw", label: "Draw" }, { value: "loss", label: "Loss" }] },
        { key: "score_home", label: "Our Score", type: "number" },
        { key: "score_away", label: "Opponent Score", type: "number" },
        { key: "notes", label: "Match Notes", type: "textarea", full: true },
      ]}
    />
  );
}
